module.exports = __webpack_public_path__ + "94ade2288ca40d4d30dd1560f2bcc77b.svg";